import { useDocumentDetailsV4 } from 'hooks/useDocumentDetails';
import type { Document } from 'types';
import type {
  AccessibilityCompliance,
  BuildingPermit,
  BuildingPlanReview,
  BusinessLicense,
  DevelopmentPermit,
  ElectricalInspection,
  EnvironmentalResourcePermit,
  LandTitleChange,
  LandUseRedesignation,
  MechanicalPermit,
  MunicipalHearing,
  PlatDocumentType,
  PlumbingPermit,
} from 'types/Documents';

export const useAccessibilityComplianceV4 = (documentId: string | undefined) => {
  return useDocumentDetailsV4<Document<AccessibilityCompliance> | undefined>(
    documentId ?? null,
  );
};

export const useBuildingPermitV4 = (documentId: string | undefined) => {
  return useDocumentDetailsV4<Document<BuildingPermit> | undefined>(documentId ?? null);
};

export const useEnvironmentalResourcePermitV4 = (documentId: string | undefined) => {
  return useDocumentDetailsV4<Document<EnvironmentalResourcePermit> | undefined>(
    documentId ?? null,
  );
};

export const useBuildingPlanReviewV4 = (documentId: string | undefined) => {
  return useDocumentDetailsV4<Document<BuildingPlanReview> | undefined>(
    documentId ?? null,
  );
};

export const useBusinessLicenceV4 = (documentId: string | undefined) => {
  return useDocumentDetailsV4<Document<BusinessLicense> | undefined>(documentId ?? null);
};

export const useDevelopmentPermitV4 = (documentId: string | undefined) => {
  return useDocumentDetailsV4<Document<DevelopmentPermit> | undefined>(
    documentId ?? null,
  );
};

export const useElectricalInspectionV4 = (documentId: string | undefined) => {
  return useDocumentDetailsV4<Document<ElectricalInspection> | undefined>(
    documentId ?? null,
  );
};

export const useLandTitleChangeV4 = (documentId: string | undefined) => {
  return useDocumentDetailsV4<LandTitleChange | undefined>(documentId ?? null);
};

export const useLandUseRedesignationV4 = (documentId: string | undefined) => {
  return useDocumentDetailsV4<Document<LandUseRedesignation> | undefined>(
    documentId ?? null,
  );
};

export const useMechanicalPermitV4 = (documentId: string | undefined) => {
  return useDocumentDetailsV4<Document<MechanicalPermit> | undefined>(documentId ?? null);
};

export const useMunicipalHearingV4 = (documentId: string | undefined) => {
  return useDocumentDetailsV4<Document<MunicipalHearing> | undefined>(documentId ?? null);
};

export const usePlatV4 = (documentId: string | undefined) => {
  return useDocumentDetailsV4<Document<PlatDocumentType> | undefined>(documentId ?? null);
};

export const usePlumbingPermitV4 = (documentId: string | undefined) => {
  return useDocumentDetailsV4<Document<PlumbingPermit> | undefined>(documentId ?? null);
};
